import React from 'react';
import './NavigationBarToggle.css';
import logo from '../../images/logo2.png';
import maleprofile from '../../images/male-user.png';
import {  Collapse,Navbar, NavbarToggler,Nav,NavItem,NavLink,Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/fontawesome-free-solid';
import { faEnvelope} from '@fortawesome/fontawesome-free-regular';
import UserManager from '../../Core/UserManager';
import Config from '../../Core/Config.js';
import {framework} from 'saffroncodejs';
import Axios from 'axios';
var PageManager = framework.PageManager ;

class Navheader extends React.Component {
    constructor(props) {
        super(props);
        this.username = "نام کاربر";
        this.toggle = this.toggle.bind(this);
        this.toggle2 = this.toggle2.bind(this);
        this.state = {
            isOpen: false,
            visible:UserManager.isLogin(),
            modal: false,
            nestedModal: false,
            closeAll: false,
            userProfileInfo:[],
            notifMessages:0
        };
        this.logOutoutStatus = this.logOutoutStatus.bind(this);
        this.changeLoginStatus = this.changeLoginStatus.bind(this);
        UserManager.dispatcher.addEventListner(UserManager.LOGGED_IN,this.changeLoginStatus);
        UserManager.dispatcher.addEventListner(UserManager.LOGGED_OUT,this.logOutoutStatus);
        this.toggleNested = this.toggleNested.bind(this);
        this.toggleAll = this.toggleAll.bind(this);
        
    Axios.get(Config.domain_pic + "/GetUnreadMessagesCount?UserId=" + UserManager.getUserToken()
    )
      .then((result) => {
        this.setState({ notifMessages: result.data, isloading: false });
        console.log("result.GetUnreadMessagesCount: ", result.data);
        
      }
      )
    this.loadProfile();
    }
    loadProfile(){
        Axios.get(Config.domain_pic + "/GetUsersProfile?" +
            "LanguageBaseId=" + 11 + "&UserId=" + UserManager.getUserToken()+ "&OtherUserId=" +UserManager.getUserToken()
        )
            .then((result) => {
                // console.log("result.userprofile: ", JSON.stringify(result.data));
                this.setState({ userProfileInfo: result.data, isLoading: false
                });

            })
            .catch((error) => {
                alert(error) 
            })
            
    }
    
    changeLoginStatus()
    {
        this.setState(
            {
                visible: true
            }
        );
    }
    logOutoutStatus()
    {
        this.setState(
            {
                visible: false
            }

        );
    }

    toggle() {
        this.setState({
        isOpen: !this.state.isOpen
        });
    }
    toggle2() {
        this.setState({
        modal: !this.state.modal
        });
    }
    toggleNested() {
        this.setState({
          nestedModal: !this.state.nestedModal,
          closeAll: false
        });
      }
    
      toggleAll() {
        this.setState({
          nestedModal: !this.state.nestedModal,
          closeAll: true
        });
    }

    render() {
        
        
        if(this.state.visible===false)
        {
            return null;
        }
        return (
            <span>
            <span className="navbar-header">
            <img alt="" src={logo} className="img-responsive" />
            <FontAwesomeIcon icon={faEnvelope} className="headerMessage" onClick={()=>PageManager.changePage(Config.p_receivedmessages)} /><span className="bdg" onClick={()=>PageManager.changePage(Config.p_receivedmessages)}>{this.state.notifMessages}</span>
            </span>
            <span className="navbar-header"> 
            {/*  <Row className="navbar-header">
                <NavbarBrand href="/"><img alt="" src={logo} className="img-responsive" /></NavbarBrand> */}
             
        <Navbar color="light" light expand="md">
        
        {/* Modal */}
        <Button className="userprofilerow " outline color="secondary"  onClick={this.toggle2}><img alt="" className="pull-right profile-img" src={maleprofile} />
                                </Button>

        <Modal isOpen={this.state.modal} toggle={this.toggle2} className="login_popup">
          <ModalHeader toggle={this.toggle2}></ModalHeader>
          <ModalBody>
            {this.state.userProfileInfo.slice(0,1).map((p)=>
                {
                    return(
                        <span>
                            <div className="userprofilerow">{p.PhotoName!==null?(<img src={'http://mobapp.novininsurance.com/UploadImages/UserProfile/'+p.PhotoName+'.jpg'} alt={p.UserName} className="pull-right profile-img" />):(<img alt="" className="pull-right profile-img" src={maleprofile} />)}<span className="pull-right">{p.FirstName+' '+p.LastName} </span></div>
                            <br />
                        </span>
                    )
                }
            )
            }
            
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={()=>PageManager.changePage(Config.p_profileinfo)}>حساب کاربری</Button>&nbsp;
            <Button color="secondary" onClick={()=>UserManager.logOut()}>خروج</Button>
          </ModalFooter>
        </Modal>
        {/* Modal */}
        
          <NavbarToggler onClick={this.toggle} icon={faBars}/>
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
            {Config.menuPages.map((item)=>{
                                return  <NavItem onClick={()=>PageManager.changePage(item)} >
                                            <NavLink><div className="bullet"></div>{item.pageName}</NavLink>
                                        </NavItem>
                            })}
              
              
            </Nav>
            
          </Collapse>
        </Navbar>
        


                {/* <div>
                    <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                        <DropdownToggle >
                            <FontAwesomeIcon icon={faBars} />
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem className="header-menu">
                                <img alt="" src={logo} className="img-responsive logo-menu" />
                                <img alt="" src={close} className="close" />
                            </DropdownItem>
                            <DropdownItem className="header-menu">
                                <div className="userprofilerow"><img alt="" className="pull-right profile-img" src={maleprofile} /><span>{this.username}</span>
                                </div>
                            </DropdownItem>
                            {Config.menuPages.map((item)=>{
                                return  <DropdownItem onClick={()=>PageManager.changePage(item)} >
                                            <NavLink><div className="bullet"></div>{item.pageName}</NavLink>
                                        </DropdownItem>
                            })}
                            <DropdownItem onClick={()=>UserManager.logOut()} >
                                <NavLink><div className="bullet"></div>خروج</NavLink>
                            </DropdownItem>

                        </DropdownMenu>
                    </Dropdown>
                </div> 
             </Row>*/}
            </span>
            </span>
        );
    }
}
export { Navheader };


// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationBarToggle.js